export const OPTIMIZATION_NAMESPACE = 'optimization';
